var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',_vm._g(_vm._b({attrs:{"items":_vm.fonctions,"aria-autocomplete":"none","data-testid":_vm.dataTestid},on:{"update:search-input":_vm.updateInputValue}},'v-combobox',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }